
  import api from '@/api';

  import {Component, Prop, Vue} from "vue-property-decorator";
  import {ProfitType} from "@/api/appService";

  @Component({name: 'ReportTip'})
  export default class ReportTip extends Vue {

    @Prop({required: true})
    year!: number;

    @Prop({required: true})
    orgId!: number;

    @Prop({required: true})
    type!: ProfitType;

    hasTry  = false;

    tryRefresh() {
      for(let month = 1;month<=12;month++){
        api.profitReport.rerunReportCalc({
          body:{
            month:month,
            year:this.year,
            orgId:this.orgId,
            type:this.type
          }
        })
      }
      this.hasTry = true;

      this.$message.success('您已提交更新请求。请耐心等待程序处理。时间大约1分钟');
    }


  }
